import React,{ useContext} from 'react';

import { ThemeContext } from '../../contexts/ThemeContext';
import { projectsData } from '../../data/projectsData'
import { makeStyles } from '@mui/styles';
import { Link } from 'react-router-dom'
import { HiArrowRight } from "react-icons/hi";

import './Projects.css'
import SingleProject from './SingleProject/SingleProject';

function Projects() {

    const { theme } = useContext(ThemeContext);

    const items = ['1', '2', '3', '4'];

    const useStyles = makeStyles((t) => ({
            iconBtn: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: 40,
                height: 40,
                borderRadius: 50,
                border: `2px solid ${theme.secondary}`,
                color: theme.secondary,
                transition: 'all 0.2s',
                '&:hover': {
                    backgroundColor: theme.secondary,
                    color: theme.primary,
                    transform: 'scale(1.1)',
                    border: `2px solid ${theme.primary}`,
                },
            },
            portfolio: {
                display:'none',
                width: '100%',
                marginBottom:0,
                marginTop:20,
                height: 50,
                textAlign: 'center',
                fontFamily: 'var(--primaryFont)',
                '&:hover': {},
                [t.breakpoints.down('sm')]: {
                    display: 'block',
                },
                [t.breakpoints.down('md')]: {
                    display: 'block',
                },
            },
            icon: {
                fontSize: '1.1rem',
                transition: 'all 0.2s',
                '&:hover': {},
            },
            viewAllBtn : {
                display: 'none',
                backgroundColor: theme.primary,
                // color: theme.secondary,
                borderRadius: '0px',
                textTransform: 'inherit',
                textDecoration: 'none',
                width: '150px',
                height: '50px',
                fontSize: '1rem',
                fontWeight: '500',
                fontFamily: 'var(--primaryFont)',
                border: `1px solid ${theme.fourthly}`,
                transition: 'color 0.5s',
                '&:hover': {
                    transform: 'scale(1.05)',
                    backgroundColor: theme.tertiary,
                    color: theme.primary,
                    border: `1px solid ${theme.tertiary}`,
                },
                [t.breakpoints.down('sm')]: {
                    display: 'block',
                },
                [t.breakpoints.down('md')]: {
                    display: 'block',
                },
            },
            viewArr : {
                color: theme.secondary, 
                // backgroundColor: theme.secondary70,
                width: '40px',
                height: '40px',
                padding: '0.5rem',
                fontSize: '1.05rem',
                borderRadius: '50%',
                cursor: 'pointer',
                transition: 'background-color 0.2s',
                "&:hover": {
                    color: theme.tertiary, 
                    backgroundColor: theme.secondary,
                }
            },
        }));
    
    const classes = useStyles();

    function emptyProjects(title,button,origin) {
            return (
                <>
                {items.map((item, index) => (
                    <SingleProject
                        theme={theme}
                        name='empty'
                        button={button}
                        index={item}
                        id={item}
                        key={item}
                        origin={origin}
                        title={title}
                    />
                ))}
                </>
            );
    }   

    return (
        <>
            {projectsData.length > 0 && (
                <div>
                    <div className={classes.portfolio}>
                        <h4>Portfolio</h4>
                    </div>
                    <div className="empties" id="emptiesbefore" style={{backgroundColor: theme.primary}}>
                        <div className="empties--body">
                            <div className="empties--bodyContainer">
                                {emptyProjects('Portfolio','none','home')}
                            </div> 
                        </div>
                    </div>
                    <div className="projects" id="projects" style={{backgroundColor: theme.primary}}>
                        <div className="projects--body">
                            <div className="projects--bodyContainer">
                                {projectsData.slice(0, 3).map(project => (
                                    <SingleProject
                                        theme={theme}
                                        key={project.id}
                                        id={project.id}
                                        name={project.projectName}
                                        desc={project.projectDesc}
                                        tags={project.tags}
                                        code={project.code}
                                        url={project.url}
                                        image={project.image}
                                        origin='home'
                                    />
                                ))}
                            </div> 
                        </div>
                    </div>
                    <div className="empties" id="emptiesafter" style={{backgroundColor: theme.primary}}>
                        <div className="empties--body">
                            <div className="empties--bodyContainer">
                                {emptyProjects('none','displaymore','home')}
                            </div> 
                        </div>
                    </div>
                    <div className="viewAll">
                        <Link to="/portfolio">
                            <button className={classes.viewAllBtn}>
                                Voir plus
                                <HiArrowRight className={classes.viewArr} />
                            </button>
                        </Link>
                    </div>
                </div>
            )}

        </>
    )
}

export default Projects
